import { Component, Input } from '@angular/core';
import { TrafficLight, TrafficLights } from '@app/pcs/models';
import { hasValue, safeProp } from '@util';

@Component({
  selector: 'pcs-traffic-lights-list',
  templateUrl: './traffic-lights-list-column.component.html',
  styleUrls: ['./traffic-lights-list-column.component.scss']
})
export class TrafficLightsListColumnComponent {
  @Input() trafficLights: TrafficLights[];
  @Input() extended = false;

  applicant(trafficLights: TrafficLights) {
    return safeProp('applicant', trafficLights);
  }

  im(trafficLights: TrafficLights) {
    return safeProp('im', trafficLights);
  }

  coss(trafficLights: TrafficLights) {
    return safeProp('coss', trafficLights);
  }

  hasValue(trafficLight: TrafficLight) {
    return hasValue(trafficLight);
  }
}
